import React, { useSyncExternalStore } from "react";
import { Center } from "@/shared/ui/Blocks";
import Rive from "@rive-app/react-canvas";
import assessioaiLoaderUrl from "@/shared/ui/Loaders/Circles/assessioai_loader.riv?url";
import {
  subscribeFullPageLoader,
  getFullPageLoaderSnapshot,
} from "@/shared/lib/full-page-loader";
import { TypewriterText } from "@/shared/ui/TypewriterText";

export function FullPageLoaderOverlay() {
  const { visible, message } = useSyncExternalStore(
    subscribeFullPageLoader,
    getFullPageLoaderSnapshot
  );

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white transition-[opacity,visibility] duration-200"
      style={{
        opacity: visible ? 1 : 0,
        visibility: visible ? "visible" : "hidden",
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      <Center className="relative w-full h-full min-h-[150px] min-w-[150px]">
        <div className="flex flex-col items-center gap-4">
          <Rive src={assessioaiLoaderUrl} className="w-[150px] h-[150px]" />
          <TypewriterText text={message} />
        </div>
      </Center>
    </div>
  );
}

export default FullPageLoaderOverlay;
